import api from '@/api/uploadData'

const state = {

}

const actions = {
  uploadData (context, params) {
    return api.uploadData(params)
  },
  getUploadDataStatusInfo (context, params) {
    return api.getUploadDataStatusInfo(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
